import { Component, Input, OnDestroy, OnInit } from '@angular/core'

import { Subscription } from 'rxjs'
import {
  ComputedRecord,
  MachineStateComputed,
} from '../../../../models/states-computed.models'

import { TouaregControlStateParamsService } from '../../../../services/touareg-control-state-params.service'
import { TouaregControlStateMachineService } from '../../../../services/touareg-control-state-machine.service'
import { TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component';
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-state-drop-blocked-by-user',
  templateUrl: './touareg-control-state-drop-blocked-by-user.component.html',
  styleUrls: ['./touareg-control-state-drop-blocked-by-user.component.scss'],
  imports: [TouaregControlStateLayoutComponent, Samv2Module],
})
export class TouaregControlStateDropBlockedByUserComponent
  implements OnDestroy
{
  @Input()
  state!: MachineStateComputed

  public modeFetching!: boolean

  private _isActionDoneSubs$!: Subscription

  constructor(private _stateMachine: TouaregControlStateMachineService) {}

  public onAccept() {
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
    let state$ = this._stateMachine.actionFinalConfirm()
    this._isActionDoneSubs$ = state$.subscribe((s) => (this.modeFetching = !s))
  }

  public onSuggestion(tags: ComputedRecord[]) {
    this._stateMachine.actionDropTagReject(tags)
  }

  public onSelection(tags: ComputedRecord[]) {
    this._stateMachine.actionDropTagChoices(tags)
  }

  public deSelection(tags: ComputedRecord[]) {
    this._stateMachine.actionDropTagReject(tags)
  }

  public onManualAdd(tags: any[]) {
    if (tags?.length) {
      this._stateMachine.actionManualDropTagChoices(tags)
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // if (!!this._touaregStatesSubs$) this._touaregStatesSubs$.unsubscribe()
    if (!!this._isActionDoneSubs$) this._isActionDoneSubs$.unsubscribe()
  }
}
